<script lang="ts">
  export let variant: 'host' | 'player' = 'player';
</script>

<aside class="bigscreen">
  {#if variant === 'host'}
    <p class="title">📺 This screen is the game display</p>
    <p class="body">It shows the room code, plays the music and reveals the answers. It can't also be used to play, so everyone (including you) joins from their own phone as a controller. Hosting from a tablet or phone works too; just use a different phone to play.</p>
  {:else}
    <p class="title">📺 BANGER! needs one big screen</p>
    <p class="body">Start the game on a laptop, desktop or tablet hooked up to your TV or speakers. That's where the music plays and the answers are revealed. Everyone else joins from their phone, which becomes their game controller.</p>
  {/if}
</aside>

<style>
  .bigscreen { max-width: 42ch; margin: 18px auto 0; padding: 0 4px; text-align: center; color: var(--cyan); opacity: 0.7; font-size: 0.85rem; line-height: 1.45; overflow-wrap: anywhere; }
  .bigscreen p { margin: 0; }
  .title { font-weight: 800; margin-bottom: 4px !important; }
  .body { color: #fff; opacity: 0.8; }
</style>
